export const HEALTHCHECK = 'HEALTHCHECK'
export const HEALTHCHECK_SUCCESS = 'HEALTHCHECK_SUCCESS'
export const HEALTHCHECK_FAILURE = 'HEALTHCHECK_FAILURE'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN = 'LOGIN'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'
export const AUTHORIZE = 'AUTHORIZE'
export const AUTHORIZE_FAILURE = 'AUTHORIZE_FAILURE'
export const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const CANNOT_USE = 'CANNOT_USE'
export const CLEAR_AUTH_STATUS = 'CLEAR_AUTH_STATUS'

export const PASSWORD_RESET_MAIL_SEND = 'PASSWORD_RESET_MAIL_SEND'
export const PASSWORD_RESET_MAIL_SEND_SUCCESS = 'PASSWORD_RESET_MAIL_SEND_SUCCESS'
export const PASSWORD_RESET_MAIL_SEND_FAILURE = 'PASSWORD_RESET_MAIL_SEND_FAILURE'
export const PASSWORD_RESET_UPDATE = 'PASSWORD_RESET_UPDATE'
export const PASSWORD_RESET_UPDATE_SUCCESS = 'PASSWORD_RESET_UPDATE_SUCCESS'
export const PASSWORD_RESET_UPDATE_FAILURE = 'PASSWORD_RESET_UPDATE_FAILURE'

export const MORAL_GET = 'MORAL_GET'
export const MORAL_GET_FAILURE = 'MORAL_GET_FAILURE'
export const MORAL_GET_SUCCESS = 'MORAL_GET_SUCCESS'
export const MORAL_UPDATE = 'MORAL_UPDATE'
export const MORAL_UPDATE_FAILURE = 'MORAL_UPDATE_FAILURE'
export const MORAL_UPDATE_SUCCESS = 'MORAL_UPDATE_SUCCESS'
export const MORAL_ALL_ANSWERED = 'MORAL_ALL_ANSWERED'
export const MORAL_ALL_ANSWERED_FAILURE = 'MORAL_ALL_ANSWERED_FAILURE'
export const MORAL_ALL_ANSWERED_SUCCESS = 'MORAL_ALL_ANSWERED_SUCCESS'
export const RESULT_SEND = 'RESULT_SEND'
export const RESULT_SEND_FAILURE = 'RESULT_SEND_FAILURE'
export const RESULT_SEND_SUCCESS = 'RESULT_SEND_SUCCESS'
export const MORAL_END = 'MORAL_END'
export const MORAL_END_FAILURE = 'MORAL_END_FAILURE'
export const MORAL_END_SUCCESS = 'MORAL_END_SUCCESS'
export const MESSAGE_SEND = 'MESSAGE_SEND'
export const MESSAGE_SEND_FAILURE = 'MESSAGE_SEND_FAILURE'
export const MESSAGE_SEND_SUCCESS = 'MESSAGE_SEND_SUCCESS'
export const MORAL_NOANSWER_LIST = 'MORAL_NOANSWER_LIST'
export const MORAL_NOANSWER_LIST_FAILURE = 'MORAL_NOANSWER_LIST_FAILURE'
export const MORAL_NOANSWER_LIST_SUCCESS = 'MORAL_NOANSWER_LIST_SUCCESS'

export const GET_TARGETMORAL_COUNT = 'GET_TARGETMORAL_COUNT'
export const GET_TARGETMORAL_COUNT_FAILURE = 'GET_TARGETMORAL_COUNT_FAILURE'
export const GET_TARGETMORAL_COUNT_SUCCESS = 'GET_TARGETMORAL_COUNT_SUCCESS'
export const GET_NOANSWERMORAL_COUNT = 'GET_NOANSWERMORAL_COUNT'
export const GET_NOANSWERMORAL_COUNT_FAILURE = 'GET_NOANSWERMORAL_COUNT_FAILURE'
export const GET_NOANSWERMORAL_COUNT_SUCCESS = 'GET_NOANSWERMORAL_COUNT_SUCCESS'
export const GET_MESSAGEMANAGER_COUNT = 'GET_MESSAGEMANAGER_COUNT'
export const GET_MESSAGEMANAGER_COUNT_FAILURE = 'GET_MESSAGEMANAGER_COUNT_FAILURE'
export const GET_MESSAGEMANAGER_COUNT_SUCCESS = 'GET_MESSAGEMANAGER_COUNT_SUCCESS'
export const GET_MESSAGEOFFICER_COUNT = 'GET_MESSAGEOFFICER_COUNT'
export const GET_MESSAGEOFFICER_COUNT_FAILURE = 'GET_MESSAGEOFFICER_COUNT_FAILURE'
export const GET_MESSAGEOFFICER_COUNT_SUCCESS = 'GET_MESSAGEOFFICER_COUNT_SUCCESS'
export const GET_MESSAGEHARASSMENT_COUNT = 'GET_MESSAGEHARASSMENT_COUNT'
export const GET_MESSAGEHARASSMENT_COUNT_FAILURE = 'GET_MESSAGEHARASSMENT_COUNT_FAILURE'
export const GET_MESSAGEHARASSMENT_COUNT_SUCCESS = 'GET_MESSAGEHARASSMENT_COUNT_SUCCESS'
export const GET_MAGAZINE = 'GET_MAGAZINE'
export const GET_MAGAZINE_FAILURE = 'GET_MAGAZINE_FAILURE'
export const GET_MAGAZINE_SUCCESS = 'GET_MAGAZINE_SUCCESS'
export const GO_KISOKU = 'GO_KISOKU'
export const GO_YESWECAN = 'GO_YESWECAN'

export const PROFILE_DETAIL = 'PROFILE_DETAIL'
export const PROFILE_DETAIL_FAILURE = 'PROFILE_DETAIL_FAILURE'
export const PROFILE_DETAIL_SUCCESS = 'PROFILE_DETAIL_SUCCESS'
export const PROFILE_EDIT = 'PROFILE_EDIT'
export const PROFILE_EDIT_FAILURE = 'PROFILE_EDIT_FAILURE'
export const PROFILE_EDIT_SUCCESS = 'PROFILE_EDIT_SUCCESS'
export const PROFILE_UPDATE = 'PROFILE_UPDATE'
export const PROFILE_UPDATE_FAILURE = 'PROFILE_UPDATE_FAILURE'
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS'
export const PROFILE_IMAGE_UPLOAD = 'PROFILE_IMAGE_UPLOAD'
export const PROFILE_IMAGE_UPLOAD_FAILURE = 'PROFILE_IMAGE_UPLOAD_FAILURE'
export const PROFILE_IMAGE_UPLOAD_SUCCESS = 'PROFILE_IMAGE_UPLOAD_SUCCESS'

export const GET_UNAPPROVED_PROPOSE_COUNT = 'GET_UNAPPROVED_PROPOSE_COUNT'
export const GET_UNAPPROVED_PROPOSE_COUNT_FAILURE = 'GET_UNAPPROVED_PROPOSE_COUNT_FAILURE'
export const GET_UNAPPROVED_PROPOSE_COUNT_SUCCESS = 'GET_UNAPPROVED_PROPOSE_COUNT_SUCCESS'
export const EXIST_REQUEST_HOLIDAY_NOTICE = 'EXIST_REQUEST_HOLIDAY_NOTICE'
export const EXIST_REQUEST_HOLIDAY_NOTICE_FAILURE = 'EXIST_REQUEST_HOLIDAY_NOTICE_FAILURE'
export const EXIST_REQUEST_HOLIDAY_NOTICE_SUCCESS = 'EXIST_REQUEST_HOLIDAY_NOTICE_SUCCESS'
export const GET_SHIFT_NOTICE_COUNT = 'GET_SHIFT_NOTICE_COUNT'
export const GET_SHIFT_NOTICE_COUNT_FAILURE = 'GET_SHIFT_NOTICE_COUNT_FAILURE'
export const GET_SHIFT_NOTICE_COUNT_SUCCESS = 'GET_SHIFT_NOTICE_COUNT_SUCCESS'

export const JOIN_USER_SEARCH = 'JOIN_USER_SEARCH'
export const JOIN_USER_SEARCH_FAILURE = 'JOIN_USER_SEARCH_FAILURE'
export const JOIN_USER_SEARCH_SUCCESS = 'JOIN_USER_SEARCH_SUCCESS'
export const PROPOSE_IMAGE_UPLOAD = 'PROPOSE_IMAGE_UPLOAD'
export const PROPOSE_IMAGE_UPLOAD_FAILURE = 'PROPOSE_IMAGE_UPLOAD_FAILURE'
export const PROPOSE_IMAGE_UPLOAD_SUCCESS = 'PROPOSE_IMAGE_UPLOAD_SUCCESS'
export const PROPOSE_CREATE = 'PROPOSE_CREATE'
export const PROPOSE_CREATE_FAILURE = 'PROPOSE_CREATE_FAILURE'
export const PROPOSE_CREATE_SUCCESS = 'PROPOSE_CREATE_SUCCESS'
export const PROPOSE_LIST_SEARCH = 'PROPOSE_LIST_SEARCH'
export const PROPOSE_LIST_SEARCH_FAILURE = 'PROPOSE_LIST_SEARCH_FAILURE'
export const PROPOSE_LIST_SEARCH_SUCCESS = 'PROPOSE_LIST_SEARCH_SUCCESS'
export const PROPOSE_DETAIL = 'PROPOSE_DETAIL'
export const PROPOSE_DETAIL_FAILURE = 'PROPOSE_DETAIL_FAILURE'
export const PROPOSE_DETAIL_SUCCESS = 'PROPOSE_DETAIL_SUCCESS'
export const PROPOSE_EDIT = 'PROPOSE_EDIT'
export const PROPOSE_EDIT_FAILURE = 'PROPOSE_EDIT_FAILURE'
export const PROPOSE_EDIT_SUCCESS = 'PROPOSE_EDIT_SUCCESS'
export const PROPOSE_UPDATE = 'PROPOSE_UPDATE'
export const PROPOSE_UPDATE_FAILURE = 'PROPOSE_UPDATE_FAILURE'
export const PROPOSE_UPDATE_SUCCESS = 'PROPOSE_UPDATE_SUCCESS'
export const PROPOSE_DELETE = 'PROPOSE_DELETE'
export const PROPOSE_DELETE_FAILURE = 'PROPOSE_DELETE_FAILURE'
export const PROPOSE_DELETE_SUCCESS = 'PROPOSE_DELETE_SUCCESS'
export const PROPOSE_UPDATE_ON_ALREADY_READ = 'PROPOSE_UPDATE_ON_ALREADY_READ'
export const PROPOSE_UPDATE_ON_ALREADY_READ_FAILURE = 'PROPOSE_UPDATE_ON_ALREADY_READ_FAILURE'
export const PROPOSE_UPDATE_ON_ALREADY_READ_SUCCESS = 'PROPOSE_UPDATE_ON_ALREADY_READ_SUCCESS'
export const GET_REJECTED_COUNT = 'GET_REJECTED_COUNT'
export const GET_REJECTED_COUNT_FAILURE = 'GET_REJECTED_COUNT_FAILURE'
export const GET_REJECTED_COUNT_SUCCESS = 'GET_REJECTED_COUNT_SUCCESS'

export const SHOP_DETAIL = 'SHOP_DETAIL'
export const SHOP_DETAIL_FAILURE = 'SHOP_DETAIL_FAILURE'
export const SHOP_DETAIL_SUCCESS = 'SHOP_DETAIL_SUCCESS'
export const PROPOSE_KEYWORD_SEARCH = 'PROPOSE_KEYWORD_SEARCH'
export const PROPOSE_KEYWORD_SEARCH_FAILURE = 'PROPOSE_KEYWORD_SEARCH_FAILURE'
export const PROPOSE_KEYWORD_SEARCH_SUCCESS = 'PROPOSE_KEYWORD_SEARCH_SUCCESS'

export const PROPOSE_TASK_GET = 'PROPOSE_TASK_GET'
export const PROPOSE_TASK_GET_FAILURE = 'PROPOSE_TASK_GET_FAILURE'
export const PROPOSE_TASK_GET_SUCCESS = 'PROPOSE_TASK_GET_SUCCESS'

export const EXIST_PROPOSE_NOTICE = 'EXIST_PROPOSE_NOTICE'
export const EXIST_PROPOSE_NOTICE_SUCCESS = 'EXIST_PROPOSE_NOTICE_SUCCESS'
export const EXIST_PROPOSE_NOTICE_FAILURE = 'EXIST_PROPOSE_NOTICE_FAILURE'
export const DELETE_PROPOSE_NOTICE = 'DELETE_PROPOSE_NOTICE'
export const DELETE_PROPOSE_NOTICE_SUCCESS = 'DELETE_PROPOSE_NOTICE_SUCCESS'
export const DELETE_PROPOSE_NOTICE_FAILURE = 'DELETE_PROPOSE_NOTICE_FAILURE'

export const GOOD_CREATE = 'GOOD_CREATE'
export const GOOD_CREATE_FAILURE = 'GOOD_CREATE_FAILURE'
export const GOOD_CREATE_SUCCESS = 'GOOD_CREATE_SUCCESS'
export const GOOD_DELETE = 'GOOD_DELETE'
export const GOOD_DELETE_FAILURE = 'GOOD_DELETE_FAILURE'
export const GOOD_DELETE_SUCCESS = 'GOOD_DELETE_SUCCESS'

export const GET_MESSAGEMANAGER_LIST = 'GET_MESSAGEMANAGER_LIST'
export const GET_MESSAGEMANAGER_LIST_FAILURE = 'GET_MESSAGEMANAGER_LIST_FAILURE'
export const GET_MESSAGEMANAGER_LIST_SUCCESS = 'GET_MESSAGEMANAGER_LIST_SUCCESS'
export const GET_MESSAGEOFFICER_LIST = 'GET_MESSAGEOFFICER_LIST'
export const GET_MESSAGEOFFICER_LIST_FAILURE = 'GET_MESSAGEOFFICER_LIST_FAILURE'
export const GET_MESSAGEOFFICER_LIST_SUCCESS = 'GET_MESSAGEOFFICER_LIST_SUCCESS'
export const GET_MESSAGEHARASSMENT_LIST = 'GET_MESSAGEHARASSMENT_LIST'
export const GET_MESSAGEHARASSMENT_LIST_FAILURE = 'GET_MESSAGEHARASSMENT_LIST_FAILURE'
export const GET_MESSAGEHARASSMENT_LIST_SUCCESS = 'GET_MESSAGEHARASSMENT_LIST_SUCCESS'
export const GET_MESSAGEMANAGER_DETAIL = 'GET_MESSAGEMANAGER_DETAIL'
export const GET_MESSAGEMANAGER_DETAIL_FAILURE = 'GET_MESSAGEMANAGER_DETAIL_FAILURE'
export const GET_MESSAGEMANAGER_DETAIL_SUCCESS = 'GET_MESSAGEMANAGER_DETAIL_SUCCESS'
export const GET_MESSAGEOFFICER_DETAIL = 'GET_MESSAGEOFFICER_DETAIL'
export const GET_MESSAGEOFFICER_DETAIL_FAILURE = 'GET_MESSAGEOFFICER_DETAIL_FAILURE'
export const GET_MESSAGEOFFICER_DETAIL_SUCCESS = 'GET_MESSAGEOFFICER_DETAIL_SUCCESS'
export const GET_MESSAGEHARASSMENT_DETAIL = 'GET_MESSAGEHARASSMENT_DETAIL'
export const GET_MESSAGEHARASSMENT_DETAIL_FAILURE = 'GET_MESSAGEHARASSMENT_DETAIL_FAILURE'
export const GET_MESSAGEHARASSMENT_DETAIL_SUCCESS = 'GET_MESSAGEHARASSMENT_DETAIL_SUCCESS'
export const UPDATE_MESSAGEMANAGER_READ = 'UPDATE_MESSAGEMANAGER_READ'
export const UPDATE_MESSAGEMANAGER_READ_FAILURE = 'UPDATE_MESSAGEMANAGER_READ_FAILURE'
export const UPDATE_MESSAGEMANAGER_READ_SUCCESS = 'UPDATE_MESSAGEMANAGER_READ_SUCCESS'
export const UPDATE_MESSAGEOFFICER_READ = 'UPDATE_MESSAGEOFFICER_READ'
export const UPDATE_MESSAGEOFFICER_READ_FAILURE = 'UPDATE_MESSAGEOFFICER_READ_FAILURE'
export const UPDATE_MESSAGEOFFICER_READ_SUCCESS = 'UPDATE_MESSAGEOFFICER_READ_SUCCESS'
export const UPDATE_MESSAGEHARASSMENT_READ = 'UPDATE_MESSAGEHARASSMENT_READ'
export const UPDATE_MESSAGEHARASSMENT_READ_FAILURE = 'UPDATE_MESSAGEHARASSMENT_READ_FAILURE'
export const UPDATE_MESSAGEHARASSMENT_READ_SUCCESS = 'UPDATE_MESSAGEHARASSMENT_READ_SUCCESS'
export const MESSAGE_KEYWORD_SEARCH = 'MESSAGE_KEYWORD_SEARCH'
export const MESSAGE_KEYWORD_SEARCH_FAILURE = 'MESSAGE_KEYWORD_SEARCH_FAILURE'
export const MESSAGE_KEYWORD_SEARCH_SUCCESS = 'MESSAGE_KEYWORD_SEARCH_SUCCESS'

export const REQUEST_HOLIDAY_CREATE = 'REQUEST_HOLIDAY_CREATE'
export const REQUEST_HOLIDAY_CREATE_FAILURE = 'REQUEST_HOLIDAY_CREATE_FAILURE'
export const REQUEST_HOLIDAY_CREATE_SUCCESS = 'REQUEST_HOLIDAY_CREATE_SUCCESS'
export const GET_REQUEST_HOLIDAY = 'GET_REQUEST_HOLIDAY'
export const GET_REQUEST_HOLIDAY_FAILURE = 'GET_REQUEST_HOLIDAY_FAILURE'
export const GET_REQUEST_HOLIDAY_SUCCESS = 'GET_REQUEST_HOLIDAY_SUCCESS'

export const SHIFT_LIST_SEARCH = 'SHIFT_LIST_SEARCH'
export const SHIFT_LIST_SEARCH_FAILURE = 'SHIFT_LIST_SEARCH_FAILURE'
export const SHIFT_LIST_SEARCH_SUCCESS = 'SHIFT_LIST_SEARCH_SUCCESS'
export const SHIFT_DETAIL = 'SHIFT_DETAIL'
export const SHIFT_DETAIL_FAILURE = 'SHIFT_DETAIL_FAILURE'
export const SHIFT_DETAIL_SUCCESS = 'SHIFT_DETAIL_SUCCESS'

export const EXIST_WILL_MUST_NOTICE = 'EXIST_WILL_MUST_NOTICE'
export const EXIST_WILL_MUST_NOTICE_SUCCESS = 'EXIST_WILL_MUST_NOTICE_SUCCESS'
export const EXIST_WILL_MUST_NOTICE_FAILURE = 'EXIST_WILL_MUST_NOTICE_FAILURE'

export const EXIST_WILL_MUST_DRAFT = 'EXIST_WILL_MUST_DRAFT'
export const EXIST_WILL_MUST_DRAFT_SUCCESS = 'EXIST_WILL_MUST_DRAFT_SUCCESS'
export const EXIST_WILL_MUST_DRAFT_FAILURE = 'EXIST_WILL_MUST_DRAFT_FAILURE'
export const GET_WILL_MUST_DRAFT = 'GET_WILL_MUST_DRAFT'
export const GET_WILL_MUST_DRAFT_SUCCESS = 'GET_WILL_MUST_DRAFT_SUCCESS'
export const GET_WILL_MUST_DRAFT_FAILURE = 'GET_WILL_MUST_DRAFT_FAILURE'
export const SAVE_WILL_MUST_DRAFT = 'SAVE_WILL_MUST_DRAFT'
export const SAVE_WILL_MUST_DRAFT_SUCCESS = 'SAVE_WILL_MUST_DRAFT_SUCCESS'
export const SAVE_WILL_MUST_DRAFT_FAILURE = 'SAVE_WILL_MUST_DRAFT_FAILURE'
export const SAVE_WILL_MUST = 'SAVE_WILL_MUST'
export const SAVE_WILL_MUST_SUCCESS = 'SAVE_WILL_MUST_SUCCESS'
export const SAVE_WILL_MUST_FAILURE = 'SAVE_WILL_MUST_FAILURE'
export const GET_ALL_WILL_MUST = 'GET_ALL_WILL_MUST'
export const GET_ALL_WILL_MUST_SUCCESS = 'GET_ALL_WILL_MUST_SUCCESS'
export const GET_ALL_WILL_MUST_FAILURE = 'GET_ALL_WILL_MUST_FAILURE'
export const GET_WILL_MUST = 'GET_WILL_MUST'
export const GET_WILL_MUST_SUCCESS = 'GET_WILL_MUST_SUCCESS'
export const GET_WILL_MUST_FAILURE = 'GET_WILL_MUST_FAILURE'

export const GET_REFERRAL = 'GET_REFERRAL'
export const GET_REFERRAL_SUCCESS = 'GET_REFERRAL_SUCCESS'
export const GET_REFERRAL_FAILURE = 'GET_REFERRAL_FAILURE'

export const GET_SHOP_ALL = 'GET_SHOP_ALL'
export const GET_SHOP_ALL_SUCCESS = 'GET_SHOP_ALL_SUCCESS'
export const GET_SHOP_ALLL_FAILURE = 'GET_SHOP_ALLL_FAILURE'

export const INTRODUCTION_CREATE = 'INTRODUCTION_CREATE'
export const INTRODUCTION_CREATE_SUCCESS = 'INTRODUCTION_CREATE_SUCCESS'
export const INTRODUCTION_CREATE_FAILURE = 'INTRODUCTION_CREATE_FAILURE'
export const GET_INTRODUCTION = 'GET_INTRODUCTION'
export const GET_INTRODUCTION_SUCCESS = 'GET_INTRODUCTION_SUCCESS'
export const GET_INTRODUCTION_FAILURE = 'GET_INTRODUCTION_FAILURE'
export const PATCH_INTRODUCTION = 'PATCH_INTRODUCTION'
export const PATCH_INTRODUCTION_SUCCESS = 'PATCH_INTRODUCTION_SUCCESS'
export const PATCH_INTRODUCTION_FAILURE = 'PATCH_INTRODUCTION_FAILURE'

export const KANA_GET = 'KANA_GET'
export const KANA_GET_SUCCESS = 'KANA_GET_SUCCESS'
export const KANA_GET_FAILURE = 'KANA_GET_FAILURE'

export const GET_STEPUP_EXIST = 'GET_STEPUP_EXIST'
export const GET_STEPUP_CALL_EXIST = 'GET_STEPUP_CALL_EXIST'
export const STEPUP_NOANSWER_LIST = 'STEPUP_NOANSWER_LIST'
export const STEPUP_ANSWER_DETAIL_LIST = 'STEPUP_ANSWER_DETAIL_LIST'
export const STEPUP_ANSWER_UPDATE = 'STEPUP_ANSWER_UPDATE'
export const STEPUP_ALL_ANSWER_UPDATE = 'STEPUP_ALL_ANSWER_UPDATE'
export const GET_QUESTIONS = 'GET_QUESTIONS'

export const CARDS_WRITE_COUNT = 'CARDS_WRITE_COUNT'
export const CARDS_GET_COUNT = 'CARDS_GET_COUNT'
export const CARDS_LIKE_COUNT = 'CARDS_LIKE_COUNT'
export const CARDS_GET_LIKE_COUNT = 'CARDS_GET_LIKE_COUNT'

export const MYCARD_GET_SHOPS = 'MYCARD_GET_SHOPS'
export const MYCARD_SEARCH_USERS_BY_SHOP_ID = 'MYCARD_SEARCH_USERS_BY_SHOP_ID'
export const MYCARD_REGIST_FACING_TYPE_CARD = 'MYCARD_REGIST_FACING_TYPE_CARD'
export const GET_BASE_DESIGN = 'GET_BASE_DESIGN'
export const GET_MYCARD_LIST = 'GET_MYCARD_LIST'
export const GET_MYCARD_LIST_SUCCESS = 'GET_MYCARD_LIST_SUCCESS'
export const GET_MYCARD_FAVORITE_LIST = 'GET_MYCARD_FAVORITE_LIST'
export const GET_MYCARD_DETAIL = 'GET_MYCARD_DETAIL'
export const GET_SHOP_NAME = 'GET_SHOP_NAME'
export const CARD_LIKE_UPDATE = 'CARD_LIKE_UPDATE'
export const CARD_FAVORITE_UPDATE = 'CARD_FAVORITE_UPDATE'
export const CARD_CREATE = 'CARD_CREATE'
export const CARD_DELETE = 'CARD_DELETE'
export const CARD_UPDATE = 'CARD_UPDATE'
export const CARD_NOT_ALREADY_READ_COUNT = 'CARD_NOT_ALREADY_READ_COUNT'
export const GET_LAST_CARD = 'GET_LAST_CARD'
export const GET_UNREAD_ESMYCARD_EXIST = 'GET_UNREAD_ESMYCARD_EXIST'
export const CARD_LIKE_LIST = 'CARD_LIKE_LIST'
export const PROBLEM_REPORT_UPDATE = 'PROBLEM_REPORT_UPDATE'

export const GET_COMPANY_NOTICE_LIST = 'GET_COMPANY_NOTICE_LIST'
export const GET_UNREAD_COMPANY_NOTICE_EXIST = 'GET_UNREAD_COMPANY_NOTICE_EXIST'
export const GET_COMPANY_NOTICE_DETAIL = 'GET_COMPANY_NOTICE_DETAIL'
export const COMPANY_NOTICE_ALREADY_READ_UPDATE = 'COMPANY_NOTICE_ALREADY_READ_UPDATE'

export const GET_STOCK_SHOPMASTER_NOTICE_EXIST = 'GET_STOCK_SHOPMASTER_NOTICE_EXIST'

export const USERTYPE_ALL_GET = 'USERTYPE_ALL_GET'
export const USERTYPE_ALL_GET_FAILURE = 'USERTYPE_ALL_GET_FAILURE'
export const USERTYPE_ALL_GET_SUCCESS = 'USERTYPE_ALL_GET_SUCCESS'

export const SHOP_ALL_GET = 'SHOP_ALL_GET'
export const SHOP_ALL_GET_FAILURE = 'SHOP_ALL_GET_FAILURE'
export const SHOP_ALL_GET_SUCCESS = 'SHOP_ALL_GET_SUCCESS'

export const GET_EVALUATE_ANSWER_EXIST = 'GET_EVALUATE_ANSWER_EXIST'
export const GET_EVALUATE_ANSWER_CALL_EXIST = 'GET_EVALUATE_ANSWER_CALL_EXIST'
export const EVALUATE_ANSWER_NOANSWER_LIST = 'EVALUATE_ANSWER_NOANSWER_LIST'
export const EVALUATE_ANSWER_ANSWER_DETAIL_LIST = 'EVALUATE_ANSWER_ANSWER_DETAIL_LIST'
export const EVALUATE_ANSWER_ANSWER_UPDATE = 'EVALUATE_ANSWER_ANSWER_UPDATE'
export const EVALUATE_ANSWER_ALL_ANSWER_UPDATE = 'EVALUATE_ANSWER_ALL_ANSWER_UPDATE'

export const GET_SERVICE_ANSWER_EXIST = 'GET_SERVICE_ANSWER_EXIST'
export const GET_SERVICE_ANSWER_CALL_EXIST = 'GET_SERVICE_ANSWER_CALL_EXIST'
export const SERVICE_ANSWER_NOANSWER_LIST = 'SERVICE_ANSWER_NOANSWER_LIST'
export const SERVICE_ANSWER_TARGET_LIST = 'SERVICE_ANSWER_TARGET_LIST'
export const SERVICE_ANSWER_DETAIL_LIST = 'SERVICE_ANSWER_DETAIL_LIST'
export const SERVICE_ANSWER_ANSWER_UPDATE = 'SERVICE_ANSWER_ANSWER_UPDATE'
export const SERVICE_ANSWER_ALL_ANSWER_UPDATE = 'SERVICE_ANSWER_ALL_ANSWER_UPDATE'
export const SERVICE_ANSWER_HISTORY_LIST = 'SERVICE_ANSWER_HISTORY_LIST'
export const SERVICE_ANSWER_HISTORY_LIST_SUCCESS = 'SERVICE_ANSWER_HISTORY_LIST_SUCCESS'
export const SERVICE_ANSWER_HISTORY_LIST_FAILURE = 'SERVICE_ANSWER_HISTORY_LIST_FAILURE'
export const SERVICE_ANSWER_FEEDBACK = 'SERVICE_ANSWER_FEEDBACK'
export const SERVICE_ANSWER_FEEDBACK_SUCCESS = 'SERVICE_ANSWER_FEEDBACK_SUCCESS'
export const SERVICE_ANSWER_FEEDBACK_FAILURE = 'SERVICE_ANSWER_FEEDBACK_FAILURE'

export const GET_NOANSWER_SERVICE_QUESTION_COUNT = 'GET_NOANSWER_SERVICE_QUESTION_COUNT'
export const GET_NOANSWER_SERVICE_QUESTION_COUNT_SUCCESS = 'GET_NOANSWER_SERVICE_QUESTION_COUNT_SUCCESS'
export const GET_NOANSWER_SERVICE_QUESTION_COUNT_FAILURE = 'GET_NOANSWER_SERVICE_QUESTION_COUNT_FAILURE'
export const GET_TARGET_SERVICE_QUESTION_COUNT = 'GET_TARGET_SERVICE_QUESTION_COUNT'
export const GET_TARGET_SERVICE_QUESTION_COUNT_SUCCESS = 'GET_TARGET_SERVICE_QUESTION_COUNT_SUCCESS'
export const GET_TARGET_SERVICE_QUESTION_COUNT_FAILURE = 'GET_TARGET_SERVICE_QUESTION_COUNT_FAILURE'

export const EXIST_SAFETY_CONFIRMATION = 'EXIST_SAFETY_CONFIRMATION'
export const EXIST_SAFETY_CONFIRMATION_SUCCESS = 'EXIST_SAFETY_CONFIRMATION_SUCCESS'
export const EXIST_SAFETY_CONFIRMATION_FAILURE = 'EXIST_SAFETY_CONFIRMATION_FAILURE'

export const GET_SAFETY_CONFIRMATION_ANSWER = 'GET_SAFETY_CONFIRMATION_ANSWER'
export const UPDATE_SAFETY_CONFIRMATION_ANSWER = 'UPDATE_SAFETY_CONFIRMATION_ANSWER'

// 書類更新（P12）
export const GET_DOCUMENT_RENEWAL_TARGETS = 'GET_DOCUMENT_RENEWAL_TARGETS'
export const GET_DOCUMENT_RENEWAL_TARGETS_SUCCESS = 'GET_DOCUMENT_RENEWAL_TARGETS_SUCCESS'
export const GET_DOCUMENT_RENEWAL_TARGETS_FAILURE = 'GET_DOCUMENT_RENEWAL_TARGETS_FAILURE'
export const CREATE_DOCUMENT_RENEWAL = 'CREATE_DOCUMENT_RENEWAL'
export const CREATE_DOCUMENT_RENEWAL_SUCCESS = 'CREATE_DOCUMENT_RENEWAL_SUCCESS'
export const CREATE_DOCUMENT_RENEWAL_FAILURE = 'CREATE_DOCUMENT_RENEWAL_FAILURE'

// 給与・賞与明細（F-PAY）
export const GET_PAYROLL_DOCUMENTS = 'GET_PAYROLL_DOCUMENTS'
export const GET_PAYROLL_DOCUMENTS_SUCCESS = 'GET_PAYROLL_DOCUMENTS_SUCCESS'
export const GET_PAYROLL_DOCUMENTS_FAILURE = 'GET_PAYROLL_DOCUMENTS_FAILURE'
export const REQUEST_PAYROLL_LINK = 'REQUEST_PAYROLL_LINK'
export const REQUEST_PAYROLL_LINK_SUCCESS = 'REQUEST_PAYROLL_LINK_SUCCESS'
export const REQUEST_PAYROLL_LINK_FAILURE = 'REQUEST_PAYROLL_LINK_FAILURE'
export const GET_PAYROLL_DOCUMENT = 'GET_PAYROLL_DOCUMENT'
export const GET_PAYROLL_DOCUMENT_SUCCESS = 'GET_PAYROLL_DOCUMENT_SUCCESS'
export const GET_PAYROLL_DOCUMENT_FAILURE = 'GET_PAYROLL_DOCUMENT_FAILURE'

// 入社手続き（F-NEW）
export const GET_ONBOARDING_ME = 'GET_ONBOARDING_ME'
export const GET_ONBOARDING_ME_SUCCESS = 'GET_ONBOARDING_ME_SUCCESS'
export const GET_ONBOARDING_ME_FAILURE = 'GET_ONBOARDING_ME_FAILURE'
export const CREATE_ONBOARDING_DOCUMENT = 'CREATE_ONBOARDING_DOCUMENT'
export const CREATE_ONBOARDING_DOCUMENT_SUCCESS = 'CREATE_ONBOARDING_DOCUMENT_SUCCESS'
export const CREATE_ONBOARDING_DOCUMENT_FAILURE = 'CREATE_ONBOARDING_DOCUMENT_FAILURE'
export const UPDATE_ONBOARDING_PROFILE = 'UPDATE_ONBOARDING_PROFILE'
export const UPDATE_ONBOARDING_PROFILE_SUCCESS = 'UPDATE_ONBOARDING_PROFILE_SUCCESS'
export const UPDATE_ONBOARDING_PROFILE_FAILURE = 'UPDATE_ONBOARDING_PROFILE_FAILURE'
export const CONSENT_ONBOARDING_CONTRACT = 'CONSENT_ONBOARDING_CONTRACT'
export const CONSENT_ONBOARDING_CONTRACT_SUCCESS = 'CONSENT_ONBOARDING_CONTRACT_SUCCESS'
export const CONSENT_ONBOARDING_CONTRACT_FAILURE = 'CONSENT_ONBOARDING_CONTRACT_FAILURE'
// 書類の「なし」申告（免許証・任意保険証・車検証）
export const CREATE_ONBOARDING_NOT_APPLICABLE = 'CREATE_ONBOARDING_NOT_APPLICABLE'
export const DESTROY_ONBOARDING_NOT_APPLICABLE = 'DESTROY_ONBOARDING_NOT_APPLICABLE'
export const ONBOARDING_NOT_APPLICABLE_SUCCESS = 'ONBOARDING_NOT_APPLICABLE_SUCCESS'
export const ONBOARDING_NOT_APPLICABLE_FAILURE = 'ONBOARDING_NOT_APPLICABLE_FAILURE'
// 郵便番号から住所を引く（zipcloud）
export const SEARCH_ONBOARDING_ADDRESS = 'SEARCH_ONBOARDING_ADDRESS'

// 明細PDFのダウンロード（F-PAY 5.3.2）
export const GET_PAYROLL_DOWNLOAD_URL = 'GET_PAYROLL_DOWNLOAD_URL'
export const GET_PAYROLL_DOWNLOAD_URL_FAILURE = 'GET_PAYROLL_DOWNLOAD_URL_FAILURE'



// WEBPACK FOOTER //
// ./src/store/modules/mutation-types.js